<template>
    <div v-bind:status="status">
        <h1>Status</h1>             
        <table class="table">            
            <tr><td>Start time UTC</td><td>{{ status.serviceStartTimeUTC }}</td></tr>
            <tr><td>Uptime</td><td>{{ status.serviceUptime }}</td></tr>
            <tr><td>Working set</td><td>{{ status.serviceWorkingSetMB }} MB</td></tr>
            <tr><td>HTTP request</td><td>{{ httpRequestsGet || 0 }}</td></tr>
            <tr><td>HTTP success</td><td>{{ httpResponsesSucess || 0 }}</td></tr>
            <tr><td>HTTP errors</td><td>{{ httpResponsesError || 0 }}</td></tr>
        </table>
        <table class="table">            
            <tr><th>#</th><th>Found</th><th>Not found</th><th>Hit from cache</th><th>Hit from database</th><th>MusicBrainz</th><th>AudioDB</th><th>LastFM</th></tr>
            <tr><td>Artists</td>
                <td>{{ artistFound || 0 }}</td>
                <td>{{ artistNotFound || 0 }}</td>
                <td>{{ artistHitFromCache || 0 }}</td>
                <td>{{ artistHitFromDatabase || 0 }}</td>                                
                <td>{{ artistMusicBrainzFound || 0 }}</td>
                <td>{{ artistAudioDBFound || 0 }}</td>                
                <td>{{ artistLastFMFound || 0 }}</td>
            </tr>
            <tr><td>Albums</td>
                <td>{{ albumFound || 0 }}</td>
                <td>{{ albumNotFound || 0 }}</td>
                <td>{{ albumHitFromCache || 0 }}</td>
                <td>{{ albumHitFromDatabase || 0 }}</td>                                
                <td>{{ albumMusicBrainzFound || 0 }}</td>
                <td>{{ albumAudioDBFound || 0 }}</td>                
                <td>{{ albumLastFMFound || 0 }}</td>
            </tr>
        </table>
        <br/>
        <table class="table">            
            <tr><th>#</th><th>Found</th><th>Not found</th><th>Hit from cache</th><th>Hit from database</th><th>LyricsOVH</th><th>LyricsMania</th><th>Musixmatch</th><th>ParolesNet</th><th>AzLyrics</th></tr>
            <tr><td>Lyrics</td>
                <td>{{ lyricsFound || 0 }}</td>
                <td>{{ lyricsNotFound || 0 }}</td>
                <td>{{ lyricsHitFromCache || 0 }}</td>
                <td>{{ lyricsHitFromDatabase || 0 }}</td>                                
                <td>{{ lyricsLyricsOvhFound || 0 }}</td>
                <td>{{ lyricsLyricsManiaFound || 0 }}</td>                
                <td>{{ lyricsMusixmatchFound || 0 }}</td>
                <td>{{ lyricsParolesNetFound || 0 }}</td>
                <td>{{ lyricsAzLyricsFound || 0 }}</td>                
            </tr>
        </table>
    </div>
</template>

<script>
    
    import ApiClient from '@/tools/apiClient.js';

    let api = new ApiClient();

    export default {
        name: 'status',            
        data: function () {
            return {
                status: [],                         
                httpRequestsGet: 0,
                httpResponsesSucess: 0,
                httpResponsesError: 0,
                artistFound: 0,
                artistNotFound: 0,
                artistHitFromCache: 0,
                artistHitFromDatabase: 0,
                artistMusicBrainzFound: 0,
                artistAudioDBFound: 0,
                artistLastFMFound: 0,
                albumFound: 0,
                albumNotFound: 0,
                albumHitFromCache: 0,
                albumHitFromDatabase: 0,
                albumMusicBrainzFound: 0,
                albumAudioDBFound: 0,
                albumLastFMFound: 0,
                lyricsFound: 0,
                lyricsNotFound: 0,
                lyricsHitFromCache: 0,
                lyricsHitFromDatabase: 0,
                lyricsLyricsOvhFound: 0,
                lyricsLyricsManiaFound: 0,
                lyricsMusixmatchFound: 0,
                lyricsParolesNetFound: 0,
                lyricsAzLyricsFound: 0
            }
        },

        created: async function () {
            this.status = await api.getStatusAsync();

            this.httpRequestsGet = this.status?.appMetrics?.httpRequests?.methods?.GET;
            this.httpResponsesSucess = this.status?.appMetrics?.httpResponses?.globalStatus?.success;
            this.httpResponsesError = this.status?.appMetrics?.httpResponses?.globalStatus?.error;
            this.artistFound = this.status?.appMetrics?.Artist?.Result?.Found;
            this.artistNotFound = this.status?.appMetrics?.Artist?.Result?.NotFound;
            this.artistHitFromCache = this.status?.appMetrics?.Artist?.Result?.HitFromCache;
            this.artistHitFromDatabase = this.status?.appMetrics?.Artist?.Result?.HitFromDatabase;
            this.artistMusicBrainzFound = this.status?.appMetrics?.Artist?.Result?.Services?.MusicBrainz?.Found;
            this.artistAudioDBFound = this.status?.appMetrics?.Artist?.Result?.Services?.AudioDB?.Found;
            this.artistLastFMFound = this.status?.appMetrics?.Artist?.Result?.Services?.LastFM?.Found;

            this.albumFound = this.status?.appMetrics?.Album?.Result?.Found;
            this.albumNotFound = this.status?.appMetrics?.Album?.Result?.NotFound;
            this.albumHitFromCache = this.status?.appMetrics?.Album?.Result?.HitFromCache;
            this.albumHitFromDatabase = this.status?.appMetrics?.Album?.Result?.HitFromDatabase;
            this.albumMusicBrainzFound = this.status?.appMetrics?.Album?.Result?.Services?.MusicBrainz?.Found;
            this.albumAudioDBFound = this.status?.appMetrics?.Album?.Result?.Services?.AudioDB?.Found;
            this.albumLastFMFound = this.status?.appMetrics?.Album?.Result?.Services?.LastFM?.Found;

            this.lyricsFound = this.status?.appMetrics?.Lyrics?.Result?.Found;
            this.lyricsNotFound = this.status?.appMetrics?.Lyrics?.Result?.NotFound;
            this.lyricsHitFromCache = this.status?.appMetrics?.Lyrics?.Result?.HitFromCache;
            this.lyricsHitFromDatabase = this.status?.appMetrics?.Lyrics?.Result?.HitFromDatabase;
            this.lyricsLyricsOvhFound = this.status?.appMetrics?.Lyrics?.Result?.Services?.LyricsOvh?.Found;
            this.lyricsLyricsManiaFound = this.status?.appMetrics?.Lyrics?.Result?.Services?.LyricsMania?.Found;
            this.lyricsMusixmatchFound = this.status?.appMetrics?.Lyrics?.Result?.Services?.Musixmatch?.Found;
            this.lyricsParolesNetFound = this.status?.appMetrics?.Lyrics?.Result?.Services?.ParolesNet?.Found;
            this.lyricsAzLyricsFound = this.status?.appMetrics?.Lyrics?.Result?.Services?.AzLyrics?.Found;
        }
    }
</script>
